import React, { FunctionComponent } from "react";

import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button/Button";
import { ButtonColor } from "@/components/Button/types";

import { EnrichmentFilterConfig } from "../ListEditDetails";
import { List } from "../../../schema/list";

import { AdvisoryChip } from "./defineIcp/AdvisoryChip";
import { PositionColumn } from "./defineIcp/PositionColumn";
import { PersonalLocationColumn } from "./defineIcp/PersonalLocationColumn";
import { useIcpValidation } from "./defineIcp/useIcpValidation";

interface DefineIcpProps {
	list: List;
	titleFilters?: EnrichmentFilterConfig;
	setTitleFilters: React.Dispatch<React.SetStateAction<EnrichmentFilterConfig | undefined>>;
	prio: "first" | "second" | "third";
	title: string;
	description: string;
	error?: boolean;
}

export const DefineIcp: FunctionComponent<DefineIcpProps> = ({
	list,
	titleFilters,
	setTitleFilters,
	prio,
	title,
	description,
	error,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`defineIcps.defineIcp.${key}`);

	useIcpValidation(titleFilters, setTitleFilters, prio);

	return (
		<div className="p-4 mb-10 rounded-xl border border-gray-200 bg-brand-white self-stretch flex flex-col">
			<div className="flex items-center gap-3 mb-2">
				<div className="text-md">{title}</div>
				{prio === "first" && <AdvisoryChip />}
			</div>
			<div className="text-ssm text-text-meta mb-8">{description}</div>
			<div className="w-full flex flex-row gap-16">
				<div className="w-full flex flex-row gap-8">
					<PositionColumn
						error={error}
						list={list}
						prio={prio}
						setTitleFilters={setTitleFilters}
						titleFilters={titleFilters}
					/>
					<PersonalLocationColumn
						prio={prio}
						setTitleFilters={setTitleFilters}
						titleFilters={titleFilters}
					/>
				</div>
			</div>
			{prio !== "first" && titleFilters?.[prio] && (
				<div className="inline-flex flex-row justify-end">
					<div className="w-auto">
						<Button
							color={ButtonColor.ACTION_SECONDARY}
							title={ts("clear")}
							onClick={() => {
								setTitleFilters({
									...titleFilters,
									[prio]: undefined,
								});
							}}
						/>
					</div>
				</div>
			)}
		</div>
	);
};
